import {
  call,
  put,
  select,
} from 'redux-saga/effects';

import { triggerDownloadBlob } from '../globalHelpers';

import makeSelectMobile from '../../redux/Mobile/selectors';
import { get } from '../request';
import { DOWNLOAD_ERROR_MESSAGE } from './constants';

export function* downloadDocumentSaga({
  baseUrl,
  downloadDocumentFailure,
}, { payload: { fileUrl, modifiedFileName } }) {
  const isMobile = yield select(makeSelectMobile('isMobile'));
  try {
    const endpoint =
      `${baseUrl}/documents/download?fileUrl=${encodeURIComponent(fileUrl)}`;
    const { blob, fileName } = yield call(get, endpoint);
    const finalFileName = modifiedFileName || fileName;
    if (!isMobile) {
      yield call(triggerDownloadBlob, blob, finalFileName);
    }
  } catch {
    yield put(downloadDocumentFailure(DOWNLOAD_ERROR_MESSAGE));
  }
}
